export const FETCH_ALL = "FETCH_ALL";
export const SIGNUP = "SIGNUP";
export const SIGNIN = "SIGNIN";
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_FAILURE = 'SIGNIN_FAILURE';
export const SIGNIN_ERROR_CLEAR = 'SIGNIN_ERROR_CLEAR';
export const LOGOUT = 'LOGOUT';
export const SEARCH = "SEARCH";
